module.exports = __webpack_public_path__ + "img/bg_11.6e34e97d.png";